import { type Config, connect, getConnectors } from "@wagmi/core";

/** Connect an installed MetaMask directly; retain the chooser for other wallets. */
export async function openWalletConnection(
  config: Config,
  openModal: () => Promise<void>,
): Promise<void> {
  const connectors = getConnectors(config);
  // EIP-6963 identifies the actual extension when several providers are installed.
  const metaMask =
    connectors.find((connector) => connector.id === "io.metamask") ??
    connectors.find((connector) => connector.id === "metaMask");
  if (metaMask && (await metaMask.getProvider())) {
    // Account permissions go through wagmi and the wallet's own approval prompt.
    // A rejection is surfaced to the user; do not open a second connection flow.
    await connect(config, { connector: metaMask });
    return;
  }
  await openModal();
}
